;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import { useEffect } from 'react';
import { useSearchParams } from 'next/navigation';
import { useSessionStorage } from 'usehooks-ts';

// Ruwe strings bewaren (geen JSON) zodat het formaat in sessionStorage ongewijzigd blijft.
// usehooks-ts vangt zelf af dat sessionStorage niet beschikbaar is (SSR, geblokkeerde site-data).
const RAW_STRING_OPTIONS = {
  serializer: (value: string | null) => value ?? 'null',
  deserializer: (value: string) => (value === 'null' ? null : value),
  initializeWithValue: false,
};

const useSessionValue = (key: string) => useSessionStorage<string | null>(key, null, RAW_STRING_OPTIONS);

// Leest de utm-parameters en referrer die useUtmTracking bewaard heeft (meegestuurd bij een sollicitatie).
export const useUtmValues = () => {
  const [utm_source] = useSessionValue('utm_source');
  const [utm_medium] = useSessionValue('utm_medium');
  const [utm_campaign] = useSessionValue('utm_campaign');
  const [referrer] = useSessionValue('referrer');

  return { utm_source, utm_medium, utm_campaign, referrer };
};

// Bewaart utm-parameters en referrer in sessionStorage.
const useUtmTracking = (): void => {
  const searchParams = useSearchParams();
  const [, setUtmSource] = useSessionValue('utm_source');
  const [, setUtmMedium] = useSessionValue('utm_medium');
  const [, setUtmCampaign] = useSessionValue('utm_campaign');
  const [, setReferrer] = useSessionValue('referrer');

  useEffect(() => {
    const utmSource = searchParams.get('utm_source');
    const utmMedium = searchParams.get('utm_medium');
    const utmCampaign = searchParams.get('utm_campaign');
    if (utmSource) setUtmSource(utmSource);
    if (utmMedium) setUtmMedium(utmMedium);
    if (utmCampaign) setUtmCampaign(utmCampaign);
    setReferrer(document.referrer || null);
  }, [searchParams, setUtmSource, setUtmMedium, setUtmCampaign, setReferrer]);
};

export default useUtmTracking;
